<template>
  <div>
     <div class="Breadcrumb u-desktopOnly">
      <ul>
        <li class="Breadcrumb__item"><router-link to="/">{{ $t("home") }}</router-link></li>
        <li class="Breadcrumb__item"><span>{{ $t("faqAndSupport") }}</span></li>
      </ul>
    </div>

    <div class="PageHeader">
      <h1 class="PageHeader__heading">{{ $t("faqAndSupport") }}</h1>
    </div>

    <div class="HeroImage">
      <div class="HeroImage__content">
        <div class="Selection verticalCenter">
          <router-link class="Selection__item" to="/faq-and-support/imagic"><span v-html="$t('imagic')"></span></router-link>
          <router-link class="Selection__item" to="/faq-and-support/downloading-photos"><span>{{ $t("downloadingPhotos") }}</span></router-link>
          <router-link class="Selection__item" to="/faq-and-support/digipass"><span>{{ $t("dayDigipass") }}</span></router-link>
          <router-link class="Selection__item" to="/faq-and-support/season-digipass"><span>{{ $t("seasonDigipass") }}</span></router-link>
          <router-link class="Selection__item" to="/faq-and-support/annual-digipass"><span>{{ $t("annualDigipass") }}</span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
@import './../../styles/_variables';

.HeroImage {
  height: 26em;
  margin-bottom: 5em;
  background: url('./../../assets/bg/rollercoaster.jpg');
  background-size: cover;

  @media (min-width: 349px) {
    height: 19em;
  }

  @media (min-width: 405px) {
    height: 16em;
  }

  @media (min-width: $tabletSmall) {
    height: 26.875em;
  }
}

.Selection__item {
  @media (min-width: $tabletSmall) {
    font-size: 1.5em;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Faq/Faq.vue